import {Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import LinkUI from 'ui/LinkUI';

interface IProps {
  t: (term: TranslationKeys) => string;
}

export const General: FC<IProps> = ({t}) => {
  const links = [
    {link: '/agreement', keyWord: t('GENERAL_TEAMS')},
    {link: '/delivery-details', keyWord: t('DELIVERY_TERMS')},
  ];

  return (
    <Flex w="45%" flexDirection="column">
      <Text as="h2">{t('GENERAL')}</Text>
      {links.map((item, index) => (
        <LinkUI href={item.link} key={index}>
          <Text fontSize={['12px', '16px']} fontWeight="500" _hover={{color: colors.pink}} my="4px">
            {item.keyWord}
          </Text>
        </LinkUI>
      ))}
    </Flex>
  );
};
